<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? 'Expandir' : 'Recolher' }}</span>
                </li>


                <li @mouseover="showCadastrosMenu = true" @mouseleave="showCadastrosMenu = false">
                    <img src="@/assets/icons/menuOpcoes.svg" />
                    <span>Cadastros</span>
                    <div v-if="showCadastrosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('BairrosTabPage', 'BAIRROS')">
                                <span>Bairros</span>
                            </li>
                            <li @click="selectOption('EquipamentosTabPage', 'EQUIPAMENTOS')">
                                <span>Equipamentos</span>
                            </li>
                            <li @click="selectOption('EquipamentosGruposTabPage', 'GRUPOS DE EQUIPAMENTO')">
                                <span>Grupos de Equipamento</span>
                            </li>
                            <li @click="selectOption('OperadoresTabPage', 'OPERADORES')">
                                <span>Operadores</span>
                            </li>
                            <li @click="selectOption('PessoasTabPage', 'PESSOAS')">
                                <span>Pessoas e Produtores</span>
                            </li>
                            <li @click="selectOption('ObrasTpServicosTabPage', 'SERVIÇOS SETOR DE OBRAS')">
                                <span>Serviços</span>
                            </li>
                            <li v-if="globalStore.perfil.sis_admin===1" @click="selectOption('UsuariosTabPage', 'USUÁRIOS')">
                                <span>Usuários</span>
                            </li>
                        </ul>
                    </div>
                </li>

                <li @click="setComponenteAtivo('ObrasSolicitacoesTabPage', 'SOLICITAÇÕES RECEBIDAS')">
                    <img src="@/assets/icons/menuPhone.svg" />
                    <span>Solicitações Recebidas</span>
                </li>

                <li @click="setComponenteAtivo('ObrasOsEditPage', 'EMITIR ORDEM DE SERVIÇO')">
                    <img src="@/assets/icons/menuEngineer2.svg" />
                    <span>Emitir Ordem de Serviço</span>
                </li>

                <li @click="setComponenteAtivo('ObrasOsTabPage', 'ORDENS DE SERVIÇO')">
                    <img src="@/assets/icons/menuList.svg" />
                    <span>Ordens de Serviço</span>
                </li>

                <!-- <li @click="setComponenteAtivo('IpOsMapaExecutarPage', 'MAPA - SERVIÇOS À EXECUTAR')">
                    <img src="@/assets/icons/menuMap.svg" />
                    <span>Mapa Serviços à Executar</span>
                </li> -->

                <li @click="setComponenteAtivo('UsuarioViewPage', 'DADOS DO USUÁRIO')">
                    <img src="@/assets/icons/menuUser.svg" />
                    <span>Meus Dados</span>
                </li>

                <li @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.svg" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>

        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo ? nmTitulo : 'GESTÃO SECRETARIA DE OBRAS' }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ loginStore.userData.nome }}</div>
                        <div class="establishment-name">{{ loginStore.userData.nmmunicipio }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='ObrasOsEditPage'"><ObrasOsEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ObrasOsTabPage'"><ObrasOsTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOSGeralReportPage'"><IpOSGeralReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOSMaterialConsumidoReportPage'"><IpOSMaterialConsumidoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ObrasSolicitacoesTabPage'"><ObrasSolicitacoesTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ObrasTpServicosTabPage'"><ObrasTpServicosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosTabPage'"><UsuariosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage :idView=loginStore.userData.idusuario @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='BairrosTabPage'"><BairrosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EquipamentosTabPage'"><EquipamentosTabPage :idView=loginStore.userData.idusuario @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EquipamentosGruposTabPage'"><EquipamentosGruposTabPage :idView=loginStore.userData.idusuario @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='OperadoresTabPage'"><OperadoresTabPage :cdPerfil="3" @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PessoasTabPage'"><PessoasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else><ObrasAdminDash /></div>
                </slot>
            </div>
        </main>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { jwtDecode } from 'jwt-decode';
import { useLoginStore } from '@/store/login';
import { useRouter } from 'vue-router';
import { globalStore } from '@/globals';

import IpOSGeralReportPage from '../reports/IpOSGeralReportPage.vue';
import IpOSMaterialConsumidoReportPage from '../reports/IpOSMaterialConsumidoReportPage.vue';

// SUBMENU CADASTROS
import BairrosTabPage from '../cadastros/tabelas/BairrosTabPage.vue';
import EquipamentosTabPage from '../cadastros/tabelas/EquipamentosTabPage.vue';
import EquipamentosGruposTabPage from '../cadastros/tabelas/EquipamentosGruposTabPage.vue';
import OperadoresTabPage from '../cadastros/tabelas/OperadoresTabPage.vue';
import PessoasTabPage from '../cadastros/tabelas/PessoasTabPage.vue';

import ObrasAdminDash from '../dashboard/ObrasAdminDash.vue';
import ObrasOsEditPage from '../obras/ObrasOsEditPage.vue';
import ObrasOsTabPage from '../obras/ObrasOsTabPage.vue';
import ObrasSolicitacoesTabPage from '../obras/ObrasSolicitacoesTabPage.vue';
import ObrasTpServicosTabPage from '../cadastros/tabelas/ObrasTpServicosTabPage.vue';
import UsuariosTabPage from '../cadastros/tabelas/UsuariosTabPage.vue';
import UsuarioViewPage from '../cadastros/visualizacoes/UsuarioViewPage.vue';

const isCollapsed = ref(true);
const nmComponenteAtivo = ref(null);
const nmTitulo = ref(null);
const router = useRouter();
const showCadastrosMenu = ref(false);
const showCadastrosRelatorios = ref(false);
const timeRemaining = ref(null);
const loginStore = useLoginStore();
let timer = null;

const menuIcon = computed(() =>
  isCollapsed.value
    ? require('@/assets/icons/menuRight.svg')
    : require('@/assets/icons/menuLeft.svg')
);

const confirmLogout = () => {resetLogin();}

const resetLogin = () => {
    loginStore.clearLogin();
    router.push('/login');
}

const toggleMenu = () => { isCollapsed.value = !isCollapsed.value; }

const selectOption = (page, titulo) => {
    nmComponenteAtivo.value = page;
    nmTitulo.value = titulo;
    showCadastrosMenu.value = false; // Fecha o submenu após a seleção
    showCadastrosRelatorios.value=false;
}

const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}

const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
};

onMounted(() => {
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
});

onBeforeUnmount(() => {
    clearInterval(timer);
});
</script>

<style scoped src="@/assets/css/main.css"></style>
